import Router from "./routes";
import "./Assets/CSS/login.css";
import "./Assets/CSS/style.css";
import ThemeConfig from "./theme";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./hooks/useAuth";
import { ContentProvider } from "./hooks/useContent";

function App() {
  return (
    <ThemeConfig>
      <AuthProvider>
      <ContentProvider>
        <Router />
      </ContentProvider>
      </AuthProvider>
      <Toaster position="top-right" />
    </ThemeConfig>
  );
}

export default App;
